import React from 'react';
import { TooltipKeys } from '../../tooltips/TooltipKeys';
import UIContainer  from '../subcomponents/UIContainer';
import UIButtons  from '../subcomponents/UIButtons';
import UIVoice  from '../subcomponents/UIVoice';
import UIPreviousStep  from '../subcomponents/UIPreviousStep';
import subComponentTypes from '../subcomponents/types';
import UIEditorComponentRenderer from '../UIEditorComponentRenderer';

export default function TFinishProcedure(props)
{
	function getRawProperties()
	{
		return {
			[subComponentTypes.CONTAINER]:{ ...UIContainer({ ...props, align:'middle', title:'Procedure Complete?' }) },
			[subComponentTypes.BUTTONS]:{ ...UIButtons({ ...props, okOnly:true, okText:'Yes', wide:true }) },
			[subComponentTypes.PREVIOUS_STEP]:{ ...UIPreviousStep({ ...props }) },
			[subComponentTypes.VOICE]:{ ...UIVoice({ ...props }) }
		}
	}

	if(props.getProperties)
	{
		return getRawProperties();
	}

	function repackProperties()
	{
		let rawProperties = getRawProperties();
		// console.log(rawProperties);
		let flatProperties = [
			{
				type: 'group',
				key: 'procedure complete group',
				title: rawProperties.Container.props.title,
				subcomponent: null,
				children: [
					{
						...rawProperties.Container.props.properties.title,
						key: 'title',
						subcomponent: rawProperties.Container.props.subcomponent,
						title: "",
					},
					{
						type: 'color-alpha',
						title: "Text",
						color: {
							...rawProperties.Container.props.properties['title color'],
							key: 'title color',
							subcomponent: rawProperties.Container.props.subcomponent,
						},
						alpha: {
							...rawProperties.Container.props.properties['title alpha'],
							key: 'title alpha',
							subcomponent: rawProperties.Container.props.subcomponent,
						},
					},
					{
						type: 'color-alpha',
						title: "Background",
						color: {
							...rawProperties.Container.props.properties['background color'],
							key: 'background color',
							subcomponent: rawProperties.Container.props.subcomponent,
						},
						alpha: {
							...rawProperties.Container.props.properties['background alpha'],
							key: 'background alpha',
							subcomponent: rawProperties.Container.props.subcomponent,
						},
					},
					{
						type: 'color-alpha',
						title: "Stroke",
						color: {
							...rawProperties.Container.props.properties['shadow color'],
							key: 'shadow color',
							subcomponent: rawProperties.Container.props.subcomponent,
						},
						alpha: {
							...rawProperties.Container.props.properties['shadow alpha'],
							key: 'shadow alpha',
							subcomponent: rawProperties.Container.props.subcomponent,
						},
					},
					{
						...rawProperties.Container.props.properties['title alignment'],
						key: 'title alignment',
						type: 'align-text',
						subcomponent: rawProperties.Container.props.subcomponent,
						title: "Alignment",
					},
				]
			},
			{
				type: 'group',
				key: 'button group',
				title: 'Buttons',
				subcomponent: null,
				children: [
					{
						type: 'group',
						key: 'confirm button group',
						title: 'Confirm Button',
						subcomponent: null,
						children: [
							{
								...rawProperties.Buttons.props.properties['ok button text'],
								key: 'ok button text',
								subcomponent: rawProperties.Buttons.props.subcomponent,
								title: "",
							},
							{
								type: 'color-alpha',
								title: "Text",
								color: {
									...rawProperties.Buttons.props.properties['ok button text color'],
									key: 'ok button text color',
									subcomponent: rawProperties.Buttons.props.subcomponent,
								},
								alpha: {
									...rawProperties.Buttons.props.properties['ok button text alpha'],
									key: 'ok button text alpha',
									subcomponent: rawProperties.Buttons.props.subcomponent,
								},
							},
							{
								type: 'color-alpha',
								title: "Background",
								color: {
									...rawProperties.Buttons.props.properties['ok button background color'],
									key: 'ok button background color',
									subcomponent: rawProperties.Buttons.props.subcomponent,
								},
								alpha: {
									...rawProperties.Buttons.props.properties['ok button background alpha'],
									key: 'ok button background alpha',
									subcomponent: rawProperties.Buttons.props.subcomponent,
								},
							},
							{
								type: 'color-alpha',
								title: "Stroke",
								color: {
									...rawProperties.Buttons.props.properties['ok button shadow color'],
									key: 'ok button shadow color',
									subcomponent: rawProperties.Buttons.props.subcomponent,
								},
								alpha: {
									...rawProperties.Buttons.props.properties['ok button shadow alpha'],
									key: 'ok button shadow alpha',
									subcomponent: rawProperties.Buttons.props.subcomponent,
								},
							},
						]
					},
					{
						type: 'group',
						key: 'cancel button group',
						title: 'Cancel Button',
						subcomponent: null,
						decorator: {
							...rawProperties.Buttons.props.properties['cancel button visible'],
							key: 'cancel button visible',
							type: 'toggle-icon',
							subcomponent: rawProperties.Buttons.props.subcomponent,
							title: '',
						},
						children: [
							{
								...rawProperties.Buttons.props.properties['cancel button text'],
								key: 'cancel button text',
								subcomponent: rawProperties.Buttons.props.subcomponent,
								title: "",
							},
							{
								type: 'color-alpha',
								title: "Text",
								color: {
									...rawProperties.Buttons.props.properties['cancel button text color'],
									key: 'cancel button text color',
									subcomponent: rawProperties.Buttons.props.subcomponent,
								},
								alpha: {
									...rawProperties.Buttons.props.properties['cancel button text alpha'],
									key: 'cancel button text alpha',
									subcomponent: rawProperties.Buttons.props.subcomponent,
								},
							},
							{
								type: 'color-alpha',
								title: "Background",
								color: {
									...rawProperties.Buttons.props.properties['cancel button background color'],
									key: 'cancel button background color',
									subcomponent: rawProperties.Buttons.props.subcomponent,
								},
								alpha: {
									...rawProperties.Buttons.props.properties['cancel button background alpha'],
									key: 'cancel button background alpha',
									subcomponent: rawProperties.Buttons.props.subcomponent,
								},
							},
							{
								type: 'color-alpha',
								title: "Stroke",
								color: {
									...rawProperties.Buttons.props.properties['cancel button shadow color'],
									key: 'cancel button shadow color',
									subcomponent: rawProperties.Buttons.props.subcomponent,
								},
								alpha: {
									...rawProperties.Buttons.props.properties['cancel button shadow alpha'],
									key: 'cancel button shadow alpha',
									subcomponent: rawProperties.Buttons.props.subcomponent,
								},
							},
							{
								...rawProperties.Buttons.props.properties['cancel button link'],
								key: 'cancel button link',
								subcomponent: rawProperties.Buttons.props.subcomponent,
								title: "Target",
							},
						]
					},
				]
			},
			{
				...rawProperties.PreviousStep.props.properties.visible,
				key: 'visible',
				subcomponent: rawProperties.PreviousStep.props.subcomponent,
				title: rawProperties.PreviousStep.props.title,
			},
			{
				type: 'group',
				key: 'voice group',
				tooltip: TooltipKeys.UIVoice,
				title: rawProperties.Voice.props.title,
				subcomponent: null,
				children: [
					{
						...rawProperties.Voice.props.properties.Voice,
						key: 'Voice',
						subcomponent: rawProperties.Voice.props.subcomponent,
						title: "",
					}
				]

                
			},
		]
		return <UIEditorComponentRenderer
			{...props}
			properties={flatProperties}
		/>;
	}

	return (
		props.context === 'editor' ? 
			<>
				{repackProperties()}
			</>
			:
			<>
				<UIContainer {...props} align={'middle'} title={'Procedure Complete?'} />
				<UIButtons {...props} okOnly={true} okText={'Yes'} wide={true} />
				<UIPreviousStep {...props} />
				<UIVoice {...props} />
			</>
	);
}